import { camelize, decamelize } from '../utils/humps';
import { constants } from '@config';

let events = [];
let initialized = false;

const EVENTS_AGGREGATION_DEBOUNCE = constants.eventTracker.eventsAggregationDebounce;
const CLICK_TRACKING = constants.eventTracker.clickTracking;

const ATTRIBUTE_PREFIX = constants.eventTracker.attributePrefix;
const METRIC_PREFIX = constants.eventTracker.metricPrefix;

export default function initEventTracker () {
  if (!initialized) {
    const CLICK_TRACKING_CAMEL = camelize(CLICK_TRACKING);
    initialized = true;

    document.addEventListener('click', ({ target }) => {
      const t = target.closest(`[data-${CLICK_TRACKING}]`);
      t && trackDOMEvent(t.dataset[CLICK_TRACKING_CAMEL], t);
    });

    INKIVE.EditorFacade.on('printing.opened', () => trackEvent('print started'));
  }
}

const pushEvents = _.debounce(function () {
  INKIVE.DesygnerApi.post('business/event', { events });
  events = [];
}, EVENTS_AGGREGATION_DEBOUNCE);

export function trackEvent (event, attributes = {}, metrics = {}) {
  const e = { type: event };
  if (Object.keys(attributes).length) e.attributes = attributes;
  if (Object.keys(metrics).length) e.metrics = metrics;

  events.push(e);
  pushEvents();
}

function trackDOMEvent (event, { dataset } = { dataset: {} }) {
  const attributes = extractData(ATTRIBUTE_PREFIX, dataset);
  const metrics = extractData(METRIC_PREFIX, dataset);
  trackEvent(event, attributes, metrics);
}

function extractData (prefix, dataset) {
  const data = {};
  const dataRegex = new RegExp(`^${prefix}(.+)$`);
  const relevantKeys = Object.keys(dataset)
    .filter(key => !key.match(/\.bind$/))
    .map(key => key.match(dataRegex))
    .filter(Boolean)
    .map(d => d[1])
  ;

  for (const key of relevantKeys) {
    data[decamelize(key)] = dataset[prefix + key];
  }

  return data;
}
